<div class="container-fluid h-100 nopadding">
  <div class="row h-100 nopadding">
    <div class="col-6 nopadding h-100" style="z-index: 99">
      <ul class="nav nav-tabs tabs-left d-block d-flex flex-column justify-content-between h-100" role="tablist">
        <li
          data-cy="simple-list-selector"
          role="tab"
          class="orange-type"
          [ngClass]="{ active: typeBlockToAdd == blockType.simple }"
          (click)="onSelectChange(blockType.simple)"
          aria-controls="simple"
          data-toggle="tab"
          id="tab-simple"
        >
          <div class="d-flex block-type-item">
            <div *ngIf="isPrevue" class="ms-4"></div>
            <div *ngIf="!isPrevue" class="align-self-center rdo">
              <label for="rdo-simple" class="radio">
                <input type="radio" name="rdo" id="rdo-simple" class="hidden" [checked]="typeBlockToAdd == blockType.simple" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="align-self-center">
              <div class="d-flex">
                <div class="icon-block icon-block--list align-self-center"></div>
                <div class="orange-title fw-bold title align-self-center">{{ 'content.list-simple' | translate }}</div>
              </div>
              <div class="block-subtitle" [innerHTML]="'content.list-simple-text' | translate"></div>
            </div>
          </div>
        </li>
        <li
          data-cy="combined-list-selector"
          role="tab"
          class="orange-type"
          [ngClass]="{ active: typeBlockToAdd == blockType.combinations }"
          (click)="onSelectChange(blockType.combinations)"
        >
          <div class="d-flex block-type-item">
            <div *ngIf="isPrevue" class="ms-4"></div>
            <div *ngIf="!isPrevue" class="align-self-center rdo">
              <label for="rdo-combinations" class="radio">
                <input type="radio" name="rdo" id="rdo-combinations" class="hidden" [checked]="typeBlockToAdd == blockType.combinations" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="align-self-center">
              <div class="d-flex">
                <div class="icon-block icon-block--shuffle align-self-center"></div>
                <div class="orange-title fw-bold title align-self-center">{{ 'content.list-combination' | translate }}</div>
              </div>
              <div class="block-subtitle" [innerHTML]="'content.list-combination-text' | translate"></div>
            </div>
          </div>
        </li>
        <li
          data-cy="proximity-list-selector"
          role="tab"
          class="orange-type"
          [ngClass]="{ active: typeBlockToAdd == blockType.near }"
          (click)="onSelectChange(blockType.near)"
        >
          <div class="d-flex block-type-item">
            <div *ngIf="isPrevue" class="ms-4"></div>
            <div *ngIf="!isPrevue" class="align-self-center rdo">
              <label for="rdo-near" class="radio">
                <input type="radio" name="rdo" id="rdo-near" class="hidden" [checked]="typeBlockToAdd == blockType.near" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="align-self-center">
              <div class="d-flex">
                <div class="icon-block icon-block--swap align-self-center"></div>
                <div class="blue-title fw-bold title align-self-center">{{ 'content.list-near' | translate }}</div>
              </div>
              <div class="block-subtitle" [innerHTML]="'content.list-near-text' | translate"></div>
            </div>
          </div>
        </li>
        <li
          *ngIf="isPrevue"
          role="tab"
          class="orange-type"
          style="border-bottom: solid 0 transparent"
          [ngClass]="{ active: typeBlockToAdd == blockType.exclude }"
          (click)="onSelectChange(blockType.exclude)"
        >
          <div class="d-flex block-type-item">
            <div *ngIf="isPrevue" class="ms-4"></div>
            <div *ngIf="!isPrevue" class="align-self-center rdo">
              <label for="rdo-near" class="radio">
                <input type="radio" name="rdo" id="rdo-near" class="hidden" [checked]="typeBlockToAdd == blockType.exclude" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="align-self-center">
              <div class="d-flex">
                <div class="icon-block icon-block--forbiden align-self-center me-1"></div>
                <div class="fw-bold title align-self-center red-title">{{ 'content.content-exclude' | translate }}</div>
              </div>
              <div class="block-subtitle" [innerHTML]="'content.description-exclude' | translate"></div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="col-6 nopadding border-col">
      <ng-container *ngIf="!typeBlockToAdd">
        <div class="no-selection-section d-flex w-100 h-100">
          <div class="d-flex w-100 justify-content-center align-self-center fw-bold color-basic-600 text">
            <div class="w-100 h-100 text-center" *ngIf="!isPrevue">
              {{ 'content.select-a-type-block' | translate }}
            </div>
            <div class="w-75 text-center" *ngIf="isPrevue">
              {{ 'content.select-a-type-block-review' | translate }}
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="typeBlockToAdd">
        <div class="tab-content d-flex align-items-center justify-content-center h-100">
          <ng-container *ngIf="typeBlockToAdd == blockType.simple">
            <app-simple-type-guide-template></app-simple-type-guide-template>
          </ng-container>
          <ng-container *ngIf="typeBlockToAdd == blockType.combinations">
            <app-combination-type-guide-template></app-combination-type-guide-template>
          </ng-container>
          <ng-container *ngIf="typeBlockToAdd == blockType.near">
            <app-near-type-guide-template></app-near-type-guide-template>
          </ng-container>
          <ng-container *ngIf="typeBlockToAdd == blockType.exclude">
            <app-exclude-type-guide-template></app-exclude-type-guide-template>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>
